import { isAbortError } from "@arcgis/core/core/promiseUtils.js";

export default function errorLogger(error: unknown) {
  if (!isAbortError(error as __esri.Error)) {
    console.error(error);
    return true;
  }
  return false;
}